import * as authApi from "../api/authService";
import { LOCALSTORAGE_ACCESS_TOKEN } from "../api/constants/localStorageConstantes";
import { decodeAccessToken } from "../utils/authToken";
import {
    buildHandoffChallenge,
    createHandoffVerifier,
    storeHandoffVerifier,
    takeHandoffVerifier,
} from "../utils/googleLoginHandoff";

export async function login(credentials){
    return authApi
        .login(credentials)
        .then((response) => {
            if (response?.requiresTwoFactor === true) {
                return response;
            }
            localStorage.setItem(LOCALSTORAGE_ACCESS_TOKEN, response.token);
            const accountInformations = decodeAccessToken(response.token) || {};
            return {
                isAdAccountIdAssociated: accountInformations.isAdAccountIdAssociated,
                isAdmin: accountInformations.isAdmin,
                language: accountInformations.language,
                billingCompliant: accountInformations.billingCompliant,
                billingReason: accountInformations.billingReason,
                billingTrialExpired: accountInformations.billingTrialExpired,
                billingHasActiveSubscription: accountInformations.billingHasActiveSubscription,
                billingRequiresUpgrade: accountInformations.billingRequiresUpgrade,
                requiresNewAccount: accountInformations.requiresNewAccount,
            };
        })
        .catch((error) => {
            throw error;
        });
}

export async function verifyEmailLoginCode(payload) {
    const response = await authApi.verifyEmailLoginCode(payload);
    if (!response?.token) throw new Error("Login token unavailable.");
    localStorage.setItem(LOCALSTORAGE_ACCESS_TOKEN, response.token);
    return response;
}

export async function resendEmailLoginCode(payload) {
    return authApi.resendEmailLoginCode(payload);
}

/**
 * Leaves for Google through the API. The verifier stays in this tab so the
 * one-time code that comes back can only be exchanged here.
 */
export async function startGoogleLogin(params = {}) {
    const verifier = createHandoffVerifier();
    const handoffChallenge = await buildHandoffChallenge(verifier);
    storeHandoffVerifier(verifier);
    window.location.assign(authApi.buildGoogleLoginStartUrl({ ...params, handoffChallenge }));
}

export async function completeGoogleLogin(code) {
    const verifier = takeHandoffVerifier();
    if (!verifier) throw new Error("Google login verifier unavailable.");
    const response = await authApi.exchangeGoogleLoginCode({ code, verifier });
    if (!response?.token) throw new Error("Google login token unavailable.");
    return response.token;
}
